angular.module('leanlaw').directive('llBalanceMaybeDeleted', ['$compile', '$http', function ($compile, $http) {
  return {
    restrict: 'EA',
    scope: {
      number: '=ngModel'
    },
    template: require("./views/llBalanceMaybeDeleted.html")
  };
}]);